import { createSelector } from 'reselect';
import { addAssuranceZonePdpSelector } from 'selectors/testTarget/offers/addAssuranceZonePdp/addAssuranceZonePdpSelector';

const showSelector = createSelector(addAssuranceZonePdpSelector, addAssuranceZonePdp => !!addAssuranceZonePdp.show);

export { showSelector };
